import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/plus-jakarta-sans'
import '@fontsource-variable/space-grotesk'
// Inter is kept only for the frozen TurfAI wordmark in the logo lockup.
import '@fontsource-variable/inter'
import './styles/globals.css'
import App from './App.tsx'
import { initAnalytics } from './config/analytics'

// Loads GA4 only when VITE_GA_MEASUREMENT_ID is set; otherwise a no-op.
initAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)